import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initMetaPixel } from './utils/metaPixel';
// Initialize Meta Pixel (fires PageView automatically)
initMetaPixel('1993358478061319');
render(<App data-id="element-178" />, document.getElementById('root'));